// FR-W9: a phase-1 match renders the summary and the two resolutions.
import type { CommitResolution, VendorMatchSummary } from '@stash/shared-types';

interface MatchResolutionSheetProps {
  match: VendorMatchSummary;
  onResolve: (resolution: CommitResolution) => void;
}

export function MatchResolutionSheet({ match, onResolve }: MatchResolutionSheetProps): React.JSX.Element {
  return (
    <div className="flex flex-col gap-3 py-4 text-center">
      <p className="text-sm text-muted-foreground">
        Looks like this business is already in STASH:
      </p>
      <div className="rounded-2xl border border-border bg-card px-4 py-3 text-left">
        <p className="m-0 font-semibold text-foreground">{match.companyName}</p>
        {match.businessPhone && <p className="m-0 text-sm text-muted-foreground">{match.businessPhone}</p>}
        {match.websiteUrl && <p className="m-0 text-sm text-muted-foreground">{match.websiteUrl}</p>}
        <p className="m-0 mt-1 text-xs text-muted-foreground">matched on {match.matchedOn}</p>
      </div>
      <div className="flex justify-center gap-2">
        <button
          type="button"
          onClick={() => onResolve('useExisting')}
          className="rounded-full bg-primary px-5 py-2.5 font-semibold text-primary-foreground"
        >
          Use existing
        </button>
        <button
          type="button"
          onClick={() => onResolve('createNew')}
          className="rounded-full bg-secondary px-5 py-2.5 font-semibold text-secondary-foreground"
        >
          Create new anyway
        </button>
      </div>
    </div>
  );
}
